/* global Image */
/* global store */

export const REGEX_FOR_CACHEBUSTER = /(\[timestamp\]|\[cachebuster\]|\[TIMESTAMP\]|\[CACHEBUSTER\]|\[InsertCachebusterHere\]|%%CACHEBUSTER%%)/;
export const cachebusterFunction = () => Math.random() * 1e20;

export const replaceConsentMacros = (trackingString) => {
  const { macros } = store.getState();
  let adjustedTracking = trackingString;
  Object.keys(macros).forEach((macro) => {
    adjustedTracking = adjustedTracking.split(unescape(macro)).join(macros[macro]);
  });
  adjustedTracking = adjustedTracking.replaceAll(/\%\%.+?\%\%|\$\{.+?\}+/g, '');
  return adjustedTracking;
};

export const createTrackingPixel = (src) => {
  const pixel = new Image();
  pixel.src = src.replace(REGEX_FOR_CACHEBUSTER, cachebusterFunction());
  return pixel;
};

const isMatch = (el, s) => ((Element.prototype.msMatchesSelector !== undefined) ? el.msMatchesSelector(s) : el.webkitMatchesSelector(s));

export const getClosest = (elem, s) => {
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }
  let el = elem;
  do {
    if (isMatch(el, s)) return el;
    el = el.parentElement || el.parentNode;
  } while (el !== null && el.nodeType === 1);
  return null;
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/tracking/utils.js